import React, { useEffect, useCallback, useRef } from 'react';
import { Redirect, Route, withRouter } from 'react-router';
import cookies from 'js-cookie';
import { Spin } from 'antd';
import { checkAuthenticate } from '../../shared/services/user-services';
import { useDispatch, useSelector } from 'react-redux';
import { refreshAccessToken } from '../../redux/users';

const LAST_VISITED_PATH_KEY = 'lastVisitedPath';

const PrivateRoute = (props) => {
    const currentPath = `${props.location.pathname}${props.location.search}${props.location.hash}`;

    const dispatch = useDispatch();
    const user = useSelector((state) => state.auth);
    
    const refreshUser = async() => {
        try {
            const accessToken = cookies.get('access_token');
            const refreshToken = cookies.get('refresh_token');
            const data = { accessToken, refreshToken };
            await dispatch(refreshAccessToken(data));
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        let isMounted = true;
        if (checkAuthenticate()) {
            refreshUser();
        }
        return () => {
            isMounted = false;
        };
    },[]);

    if (!checkAuthenticate()) {
        sessionStorage.setItem(LAST_VISITED_PATH_KEY, currentPath);
        return <Redirect to='/login' />;
    } else {
        if (user.status === 'loading') {
            return (
                <Spin spinning={user.status === 'loading'}>
                    <Route {...props} />
                </Spin>
            );
        }
        else if (user.status === 'failed') {
            sessionStorage.setItem(LAST_VISITED_PATH_KEY, currentPath);
            cookies.remove('access_token');
            cookies.remove('refresh_token');
            return <Redirect to='/login' />;
        }
    }
    return <Route {...props} />;
};

export default withRouter(PrivateRoute);
